import { highlight } from '@helpers/utils/highlight/highlight';
import { ReactNode } from 'react';

import styles from './AssetCard.module.scss';

export interface AssetCardProps {
  logoNode: ReactNode;
  entity: { ticker: string; name: string };
  highlighted?: string;
  snakeName?: string;
}

export const AssetCard = ({
  logoNode,
  entity,
  highlighted,
  snakeName,
}: AssetCardProps) => {
  const { ticker, name } = entity;

  const title = `${ticker} ${snakeName ?? ''}`;
  return (
    <div className={styles.assetCardRoot} data-testid={`asset-card-${title}`}>
      {logoNode}
      <div className={styles.details}>
        <div className={styles.titleWrapper}>
          <span className={styles.title}>
            {highlighted ? highlight(ticker, highlighted) : ticker}
          </span>
          {snakeName && <span className={styles.snake}>&nbsp;{snakeName}</span>}
        </div>

        <span className={styles.subtitle}>
          {highlighted ? highlight(name, highlighted) : name}
        </span>
      </div>
    </div>
  );
};
